import { IxFilterNumberComponent, IxNgComponentsModule, IxNumberComponent } from 'ix-ng-components';
import { Component, Input, ViewChild } from '@angular/core';
import { Language } from '../../../vpoglednik/vpoglednik.enum';
import { VpoFilterHeaderComponent } from '../header/vpo-filter-header.component';

@Component({
  selector: 'lib-filter-number',
  templateUrl: './vpo-filter-number.component.html',
  imports: [VpoFilterHeaderComponent, IxNumberComponent, IxNgComponentsModule],
})
export class VpoFilterNumberComponent extends IxFilterNumberComponent {
  @Input()
  public language: Language = Language.SI;
  protected readonly Language = Language;

  @ViewChild('fieldComponent')
  private fieldComponent?: IxNumberComponent;

  override onHide() {
    super.onNumberChange(null, true);
    super.onHide();
  }

  getValue() {
    if (this.searchMode === 'field') {
      return this.value;
    }
    return this.value.replace('(od)', '').replace('(do)', ' - ');
  }

  // field input je znotraj overlaya in ne zunaj, zato se search mode override nazaj na field, ko ga framework spremeni na nekaj drugega
  override focusAndSelectActiveInput() {
    if (this.searchMode === 'field') {
      if (this.fieldComponent) {
        this.fieldComponent.ixGetFocus();
      }
    } else {
      super.focusAndSelectActiveInput();
    }
  }

  override onClickDown(event: Event) {
    const sm = this.searchMode;
    super.onClickDown(event);
    this.onSearchMode(sm);
  }
}
